<template>

    <form ref="instituicaoensinopoliticacomercial-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            
                    <div class="form-group col-md-12">
                        <label for="instituicaoEnsinoId">InstituicaoEnsino</label>
                        <select v-select="{ dataitem: 'InstituicaoEnsino', default: 'Selecione' }" v-model="model.instituicaoEnsinoId" class="form-control" name="instituicaoEnsinoId" required></select>
                    </div>
					<div class="form-group col-md-12">
                        <label for="titulo">Titulo</label>
                        <input type="text" class="form-control" name="titulo" placeholder="Titulo" v-model="model.titulo" required />
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "instituicaoensinopoliticacomercial-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "instituicaoensinopoliticacomercial-form-create",
            
            resources: {
                create: 'instituicaoensinopoliticacomercial',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

